"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiGameTicker = void 0;
var _core = require("@dragon/core");
var _gsap = _interopRequireDefault(require("gsap"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PixiGameTicker = exports.PixiGameTicker = /*#__PURE__*/function () {
  function PixiGameTicker(useGsapTicker, application) {
    var _this = this;
    _classCallCheck(this, PixiGameTicker);
    this.application = application;
    _defineProperty(this, "_useGsapTicker", void 0);
    this._useGsapTicker = useGsapTicker;
    //console.log('AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA')
    if (useGsapTicker) {
      this.application.ticker.stop();
      _gsap["default"].ticker.add(function () {
        _this.application.ticker.update();
      });
      _gsap["default"].ticker.fps(60); // Remove this to allow for higher fps, maybe it breaks something? This breaks blitz.... blitz assumes 60fps in its ring animations etc.
    } else {
      this.application.ticker.maxFPS = 60; // super computers with more than 60 fps might screw stuff over.
      this.application.ticker.minFPS = 10; // default is 10, not sure this is a good idea.
    }
  }
  return _createClass(PixiGameTicker, [{
    key: "pause",
    value: function pause() {
      if (this._useGsapTicker) {
        _gsap["default"].ticker.sleep();
      } else {
        this.application.ticker.stop();
      }
    }
  }, {
    key: "resume",
    value: function resume() {
      if (this._useGsapTicker) {
        _gsap["default"].ticker.wake();
      } else {
        this.application.ticker.start();
      }
    }
  }, {
    key: "timeScale",
    value: function timeScale(scale) {
      if (this._useGsapTicker) {
        _gsap["default"].globalTimeline.timeScale(scale);
      } else {
        console.warn('PixiGameTicker.timeScale() is not implemented for non gsap tickers');
      }
      _core.gameAnimationRegistry.timeScale(scale);
      _core.gameEmitterRegistry.timeScale(scale);
      return scale;
    }
  }]);
}();
//# sourceMappingURL=PixiGameTicker.js.map